import { QueryHookOptions, useQuery } from '@apollo/client';
import getManagedDepotsQuery from './managedDepotsQuery.graphql';

export const useManagedDepotsQuery = (
  options: QueryHookOptions<ManagedDepotsQuery, ManagedDepotsQueryVariables>,
) => {
  return useQuery<ManagedDepotsQuery, ManagedDepotsQueryVariables>(
    getManagedDepotsQuery,
    options,
  );
};
